import { Theme } from "../../../components/constants";

export default {
    drawerMenuMainContainer: {
        display: 'flex', 
        gap: '25px', 
        flexDirection: 'column'
    },
    drawerMenuItemContainer: {
        display: 'flex', 
        gap: '20px', 
        flexDirection: 'row', 
        alignItems: 'center', 
        cursor:'pointer' 
    },
    drawerMenuItemIcon: {
        width: '2.5rem', 
        height: '2.5rem'
    },
    drawerMenuItemText: {
        fontSize: '1.5rem'
    },
    drawerUserInfoContainer: { 
        alignSelf: 'center', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: '10px'
    },
    drawerUserNameContainer: { 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px' 
    },
    drawerUserNameText: {
        fontSize: '24px', 
        fontWeight: 700, 
        color: Theme.TEXT_PRIMARY_BLACK
    },
    drawerUserEditIcon: {
        cursor: 'pointer'
    },
    drawerUserTypeText: {
        fontSize: '14px', 
        fontWeight: 400, 
        color: Theme.TEXT_PRIMARY_BLACK 
    },
    optionsText: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '10px'
    },
    subMenuAncher: {
        color: '#525f7f', 
        paddingLeft: '20px'
    },
    submenuAlignment : { 
        alignItems: 'flex-start'
    }

}